export default __webpack_public_path__ + "static/media/phone_vetification.4ed33608.svg";